import {
  PaginationStyled,
  PaginationWrapper,
  SelectStyled,
  TotalRecord,
} from 'components/Pagination/styled';
import { defaultSelectPageSizeOption } from 'constant/Pagination/pageSizeOption';
import { isFunction } from 'lodash';
import useMultiLanguageCompanyList from 'page/Application/ManageCompanyList/CompanyList/hook/useMultiLanguageCompanyList';

const Pagination = ({
  total,
  currentPage,
  handlePagingChange,
  onClick,
  totalTitle,
  pageSize,
  selectPageSizeOptions,
  handleChangePageSize,
  isShowTotal = true,
  isShowPagination = true,
  isShowChangePageSize = true,
}) => {
  const {
    COMPANY_LIST_TABLE_PAGINATION_TOTAL,
    COMPANY_LIST_TABLE_PAGE_SIZE_TEXT,
  } = useMultiLanguageCompanyList();

  const customLocale = {
    items_per_page: COMPANY_LIST_TABLE_PAGE_SIZE_TEXT,
  };

  return (
    <>
      <PaginationWrapper onClick={onClick}>
        {isShowTotal ? (
          <TotalRecord>
            <span>
              {totalTitle ? totalTitle : COMPANY_LIST_TABLE_PAGINATION_TOTAL}:{' '}
              {total?.toLocaleString()}
            </span>
          </TotalRecord>
        ) : (
          <div />
        )}
        {isShowPagination ? (
          <PaginationStyled
            total={total}
            hideOnSinglePage={false}
            current={currentPage}
            pageSize={pageSize}
            onChange={handlePagingChange}
            showSizeChanger={false}
            locale={customLocale}
            showTitle={false}
          />
        ) : (
          <div />
        )}
        {isFunction(handleChangePageSize) && isShowChangePageSize ? (
          <SelectStyled
            value={pageSize}
            onChange={handleChangePageSize}
            options={selectPageSizeOptions ?? defaultSelectPageSizeOption}
            title={''}
          />
        ) : (
          <div />
        )}
      </PaginationWrapper>
    </>
  );
};

export default Pagination;
